(() => {
  if (customElements.get('qr-file-previews')) return;
  class QRFilePreviews extends HTMLElement {
    connectedCallback() {
      if (this.queued || this.ready) return;
      this.queued = true;
      queueMicrotask(() => {
        this.queued = false;
        if (!this.isConnected || this.ready) return;
        this.root = this.closest('[data-qrc-gallery-root]');
        this.dialog = this.querySelector('.qrc-file-dialog');
        if (!this.root || !this.dialog?.showModal) return;
        this.ready = true;
        this.abort = new AbortController();
        const signal = this.abort.signal;
        this.root.querySelectorAll('[data-qrc-preview]').forEach(link => link.setAttribute('aria-haspopup', 'dialog'));
        this.root.addEventListener('click', event => {
          const link = event.target.closest('[data-qrc-preview]');
          if (!link || !this.root.contains(link) || event.button !== 0 || event.ctrlKey || event.metaKey || event.altKey || event.shiftKey) return;
          event.preventDefault();
          this.opener = link;
          this.gallery = link.dataset.qrcGallery ? [...this.root.querySelectorAll('[data-qrc-preview]')].filter(item => item.dataset.qrcGallery === link.dataset.qrcGallery) : [link];
          this.showPreview(this.gallery.indexOf(link));
          document.documentElement.classList.add('qrc-modal-open');
          this.dialog.showModal();
          this.dialog.querySelector('[data-qrc-close]').focus();
        }, {signal});
        this.dialog.querySelector('[data-qrc-close]').addEventListener('click', () => this.dialog.close(), {signal});
        this.dialog.querySelector('[data-qrc-previous]').addEventListener('click', () => this.showPreview(this.activeIndex - 1), {signal});
        this.dialog.querySelector('[data-qrc-next]').addEventListener('click', () => this.showPreview(this.activeIndex + 1), {signal});
        this.dialog.addEventListener('keydown', event => {
          if (!event.ctrlKey && !event.metaKey && !event.altKey && this.gallery.length > 1 && (event.key === 'ArrowLeft' || event.key === 'ArrowRight')) {
            event.preventDefault();
            this.showPreview(this.activeIndex + (event.key === 'ArrowRight' ? 1 : -1));
          }
          if (event.key === 'Tab') {
            const focusable = [...this.dialog.querySelectorAll('button:not([disabled]), a[href], [tabindex="0"]')].filter(element => element.getClientRects().length);
            const first = focusable[0];
            const last = focusable.at(-1);
            if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
            else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
          }
        }, {signal});
        this.dialog.addEventListener('click', event => {
          if (event.target !== this.dialog) return;
          const r = this.dialog.getBoundingClientRect();
          if (event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom) this.dialog.close();
        }, {signal});
        this.dialog.addEventListener('close', () => {
          document.documentElement.classList.remove('qrc-modal-open');
          if (this.opener?.isConnected) this.opener.focus({preventScroll:true});
        }, {signal});
      });
    }
    showPreview(index) {
      this.activeIndex = (index + this.gallery.length) % this.gallery.length;
      const link = this.gallery[this.activeIndex];
      const source = link.querySelector('img');
      const image = this.dialog.querySelector('[data-qrc-file-image]');
      const width = Number(source.getAttribute('width')) || source.naturalWidth;
      const height = Number(source.getAttribute('height')) || source.naturalHeight;
      image.width = width;
      image.height = height;
      image.src = link.href;
      image.alt = source.alt;
      this.dialog.dataset.kind = link.dataset.qrcKind || 'paper';
      this.dialog.style.setProperty('--qrc-ratio', width / height);
      this.dialog.querySelector('h3').textContent = source.alt;
      this.dialog.querySelector('[data-qrc-file-caption]').textContent = link.dataset.caption;
      const warning = this.dialog.querySelector('[data-qrc-file-warning]');
      warning.textContent = link.dataset.warning || '';
      warning.hidden = !link.dataset.warning;
      const counter = this.dialog.dataset.counterTemplate.replace('__INDEX__', this.activeIndex + 1).replace('__COUNT__', this.gallery.length);
      this.dialog.querySelector('[data-qrc-count]').textContent = counter;
      this.dialog.querySelector('[data-qrc-status]').textContent = counter + ': ' + source.alt;
      this.dialog.querySelector('[data-qrc-original]').href = link.href;
      this.dialog.querySelector('.qrc-file-navigation').hidden = this.gallery.length < 2;
      this.dialog.scrollTop = 0;
    }
    disconnectedCallback() {
      this.abort?.abort();
      if (this.dialog?.open) this.dialog.close();
      if (!document.querySelector('.qrc-file-dialog[open]')) document.documentElement.classList.remove('qrc-modal-open');
      this.ready = false;
      this.queued = false;
    }
  }
  customElements.define('qr-file-previews', QRFilePreviews);
})();
